<div class="flex flex-col gap-12">

    <!-- MOODS -->
    <div class="grid grid-cols-4 w-full h-60">
        <div class="bg-[url(/assets/mood/people-1.jpg)] bg-no-repeat bg-center bg-cover rounded-s-xl"></div>
        <div class="bg-[url(/assets/mood/people-2.jpg)] bg-no-repeat bg-center bg-cover"></div>
        <div class="bg-[url(/assets/mood/people-3.jpg)] bg-no-repeat bg-center bg-cover"></div>
        <div class="bg-[url(/assets/mood/people-4.jpg)] bg-no-repeat bg-center bg-cover rounded-e-xl"></div>
    </div>

    <!-- HEADING -->
    <div class="flex flex-col gap-6">
        <h2 class="text-center text-3xl font-bold block">Merkst du noch, oder lernst du schon?</h2>

        @if (!hasPremiumAccess()) {
        <div class="flex items-center justify-center">
            <!-- SUBSCRIBE -->
            <a [routerLink]="'/subscribe/selection'" class="w-72">
                <button type="button"
                    class="bg-red-button hover:bg-red-button-dark py-3 px-4 w-full text-lg rounded-xl text-white">
                    Jetzt kostenlos testen
                </button>
            </a>
        </div>
        }

    </div>

    <!-- APPS / HELP -->

    <div class="flex flex-col md:flex-row gap-12">

        <!-- APPS -->
        <div class="flex flex-col gap-6 w-full md:w-1/2 ">

            <h2 class="text-center text-2xl font-bold hidden md:block">
                @if (hasPremiumAccess(); as hasPremiumAccess) {
                Du bist Pro-Mindpopper!
                } @else {
                Lege jetzt los!
                }
            </h2>

            <div class="shadow-lg rounded-xl p-9 bg-white flex flex-col gap-2">

                <p>
                    Lade dir die kostenlose Mindpop-App auf dein iPhone oder Android und lege sofort los
                    Vokabeln direkt zu behalten. Vor allen Dingen wünschen wir dir viel Spaß, denn mit Spaß lernt es
                    sich gleich viel besser!
                </p>
                <div class="flex flex-wrap md:flex-nowrap gap-4 items-center justify-center mt-6">

                    <!-- APPLE -->
                    <a href="https://apps.apple.com/de/app/mindpop/id6746194985" target="_blank">
                        <img src="../../../assets/stores/app-store.svg" alt="Laden im App-Store" width="300"
                            class="w-full max-w-[10rem]" />
                    </a>

                    <!-- ANDROID -->
                    <a href="https://play.google.com/store/apps/details?id=com.mindpopapp.multiplatform&hl=de"
                        target="_blank">
                        <img src="../../../assets/stores/play-store.svg" alt="Jetzt bei Google Play" width="300"
                            class="w-full max-w-[10rem]" />
                    </a>
                </div>

            </div>

            @if (hasPremiumAccess(); as hasPremiumAccess) {
            <div>
                <a href="https://help.support.mindpopapp.com/servicedesk/customer/portal/3/group/11/create/47" class="w-72">
                    <button type="button"
                        class="bg-red-button hover:bg-red-button-dark py-3 px-4 w-full text-lg rounded-xl text-white">
                        Abo kündigen
                    </button>
                </a>
            </div>
            }

        </div>

        <div class="flex flex-col gap-6 w-full md:w-1/2 ">

            <h2 class="text-center text-2xl font-bold block">Gibt`s ein Problem?</h2>

            <div class="shadow-lg rounded-xl p-9 bg-white flex flex-col gap-1 md:gap-2 h-full">

                <!-- FIRST -->
                <div class="flex gap-2 items-start justify-start">
                    <div class="flex-initial min-w-[2rem] w-8">
                        <mat-icon [svgIcon]="'seal_question'"></mat-icon>
                    </div>
                    <div class="flex-auto leading-relaxed">
                        Falls du Fragen haben solltest, Hilfe benötigst, oder uns einfach nur etwas mitteilen
                        möchtest, kannst du uns gerne eine E-Mail an <a href="mailto:support@mindpopapp.com"
                            class="underline">support&#64;mindpopapp.com</a> schreiben, oder uns
                        auf <a href="https://support.mindpopapp.com" target="_blank"
                            class="underline">support.mindpopapp.com</a>
                        besuchen.
                    </div>

                </div>
            </div>

        </div>
    </div>

    <!-- TEASER / SUBSCRIBE -->
    <div class="flex flex-col md:flex-row gap-12 sm:mb-24">

        <!-- TEASER -->
        <div class="shadow-lg rounded-xl p-9 bg-white flex flex-col gap-2 order-2 md:order-1"
            [ngClass]="{ 'w-full': hasPremiumAccess(), 'w-full md:w-1/2': !hasPremiumAccess() }">

            <div class="grid gap-4 grid-cols-1 min-[450px]:grid-cols-2"
                [ngClass]="{ 'lg:grid-cols-4': hasPremiumAccess() }">

                <img src="/assets/cards/card-1.png" alt="Pop 1" class="rounded-xl">

                <img src="/assets/cards/card-2.png" alt="Pop 2" class="rounded-xl">

                <img src="/assets/cards/card-3.png" alt="Pop 3" class="rounded-xl">

                <img src="/assets/cards/card-4.png" alt="Pop 4" class="rounded-xl">

            </div>

        </div>

        <!-- SUBSCRIBE -->
        @if (!hasPremiumAccess()) {
        <div class="shadow-lg rounded-xl p-9 bg-white flex flex-col gap-2 w-full md:w-1/2 order-1 md:order-2">

            <div class="flex flex-col gap-6">

                <h3 class="text-xl font-bold block">Sicher dir Mindpop-Premium!</h3>

                <div>
                    <!-- FIRST -->
                    <div class="flex gap-2 items-start justify-start">
                        <div class="flex-initial min-w-[2rem] w-8">
                            <mat-icon [svgIcon]="'check-mark'"></mat-icon>
                        </div>
                        <div class="flex-auto leading-relaxed">
                            Pro-Mindpoper sind 4x erfolgreicher!
                        </div>
                    </div>

                    <!-- SECOND -->
                    <div class="flex gap-2 items-start justify-start">
                        <div class="flex-initial min-w-[2rem] w-8">
                            <mat-icon [svgIcon]="'check-mark'"></mat-icon>
                        </div>
                        <div class="flex-auto leading-relaxed">
                            Komplett-Zugang zu allen Pops
                        </div>
                    </div>

                    <!-- THIRD -->
                    <div class="flex gap-2 items-start justify-start">
                        <div class="flex-initial min-w-[2rem] w-8">
                            <mat-icon [svgIcon]="'check-mark'"></mat-icon>
                        </div>
                        <div class="flex-auto leading-relaxed">
                            Vokabeln sofort behalten - ohne lernen!
                        </div>
                    </div>

                    <!-- FOURTH -->
                    <div class="flex gap-2 items-start justify-start">
                        <div class="flex-initial min-w-[2rem] w-8">
                            <mat-icon [svgIcon]="'check-mark'"></mat-icon>
                        </div>
                        <div class="flex-auto leading-relaxed">
                            Mit der Mindpop Vokabel-Behalt App lernst du die Vokabeln nicht: Du behältst sie sofort!
                        </div>
                    </div>
                </div>

                <div>
                    Du kannst Mindpop entweder abonnieren, oder einmalig bezahlen für einen zeitlich begrenzten Zugang.
                    Und
                    vor allen Dingen kannst du Premium kostenlos testen:
                </div>

                <!-- SUBSCRIBE -->
                <a [routerLink]="'/subscribe/selection'">
                    <button type="button"
                        class="bg-red-button hover:bg-red-button-dark py-5 px-4 w-full text-xl rounded-xl text-white">
                        Jetzt kostenlos testen
                    </button>
                </a>
            </div>

        </div>
        }

    </div>
</div>